import pagesVal from './pages.val.js';

/**
 * 将单层路由按注册流程转换为树形结构
 * @param  {[type]} routers [description]
 * @param  {[type]} parent  [description]
 * @return {[type]}         [description]
 */
const getRouterTree = (routers, parent) => {

  if (routers.length === 0) {
    return [];
  }

  return routers
    .filter(item => (item.component.pRouter === parent.name))
    .sort((a, b) => {
      // 根据component的rIndex 决定路由所属顺序
      const aIndex = a.component.rIndex || 0;
      const bIndex = b.component.rIndex || 0;

      return aIndex - bIndex;
    }).map(router => {

      return {
        ...router,
        next: getRouterTree(routers, router)
      }
    });
};

const routerRoot = { name: 'App', path: '/index'};
routerRoot.next = getRouterTree(pagesVal, routerRoot);
// 如果组件没有配置pRouter属性或pRouter配置错误将不会被正确挂载到虚拟路由树上

const flatRouterTree = (data) => {
  if (data.next && data.next.length === 0) {
    return data;
  }

  return data.next.reduce((acc, item) => {
    acc = acc.concat(flatRouterTree(item));

    return acc;
  }, [data]);
};
const flatRouters = flatRouterTree(routerRoot);

/**
 * 根据pRouter rIndex 跳转到下一页, 也可以使用router name跳转
 * @param  {Object} option [description]
 * @return {[type]}        [description]
 */
export const toNext = function(option = {}) {
  // console.log(this.$route)
  // console.log(option);
  const { rIndex, name, params, bdoStep, query } = option;
  const { path } = this.$route
  const mathedRouter = flatRouters.find(item => item.path === path);
  // console.log(mathedRouter)
  // 如果传入了bdoStep参数则以bdoStep匹配的页面为准
  const bdoStepRouter = bdoStep ? flatRouters.find(item => {
    const { component = {} } = item;
    console.log(component.bdoStep, bdoStep)
    return component.bdoStep === bdoStep;
  }) : null


  if (mathedRouter) {
    const childRouter = bdoStepRouter || mathedRouter.next[rIndex || 0];
    childRouter && this.$router.push({name: name || childRouter.name, params, query})
  }
};

/**
 * 根据router path 获取组件配置信息
 * @param  {[type]} path [description]
 * @return {[type]}      [description]
 */
export const getRouterPage = function(path) {
  const mathedRouter = flatRouters.find(item => item.path === path);
  // console.log(flatRouters)

  return mathedRouter;
};

/**
 * 是否正常后退(下一页返回上一页)
 * @param  {[type]} from [description]
 * @param  {[type]} to   [description]
 * @return {[type]}      [description]
 */
export const isNormalBackward = (to, from) => {
  // console.log(to, from);
  const toPage = getRouterPage(to.path);
  const fromPage = getRouterPage(from.path);
  const toComponent = toPage.component || {};
  const fromComponent = fromPage.component || {};

  // console.log({toComponent, fromComponent})

  return fromComponent && (fromComponent.pRouter === toComponent.name);
};
